import { useAtom } from "jotai";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/design-system/components/react/alert-dialog";
import { clearAllMeasurementsConfirmAtom } from "../atoms/measurementAtoms";
import { runCommand } from "../lib/commands";

/**
 * Confirm dialog for the destructive, study-wide "clear all measurements"
 * action. Rendered once at the App level; opened via clearAllMeasurementsConfirmAtom
 * by the toolbar button, the Ctrl/Cmd+Shift+Backspace shortcut, and the
 * right-click menu. On confirm it runs the clearAllMeasurements command (which
 * removes only ruler/ROI annotations and toasts the count).
 */
export function ClearAllMeasurementsDialog() {
  const [open, setOpen] = useAtom(clearAllMeasurementsConfirmAtom);

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Clear all measurements?</AlertDialogTitle>
          <AlertDialogDescription>
            This removes every ruler and rectangle ROI in this study, on all slices. Segmentation
            contours are not affected. This can&apos;t be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={() => runCommand("clearAllMeasurements", {})}>
            Clear all
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ClearAllMeasurementsDialog;
